import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "informations-content",
  class: "kn-flex kn-relative kn-height-full"
}
const _hoisted_2 = {
  key: 0,
  for: "measure",
  class: "p-error"
}
const _hoisted_3 = {
  key: 0,
  for: "label",
  class: "p-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Column = _resolveComponent("Column")
  const _component_InputText = _resolveComponent("InputText")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0 p-col-12" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('workspace.gis.indicators')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-link",
          label: _ctx.$t('workspace.gis.dsj.addIndicator'),
          onClick: _ctx.addIndicatorRow
        }, null, 8, ["label", "onClick"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        style: _ctx.styleDescriptor.style.absoluteScroll
      }, [
        _createVNode(_component_Card, null, {
          content: _withCtx(() => [
            _createVNode(_component_DataTable, {
              class: "p-datatable-sm kn-table georef-step1-table",
              value: _ctx.documentDataProp.indicators,
              responsiveLayout: "scroll",
              breakpoint: "600px"
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workspace.gis.dnl.emptyInfo')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "name",
                  header: _ctx.$t('qbe.entities.types.measure'),
                  sortable: true
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_Dropdown, {
                      id: "measure",
                      class: ["kn-material-input kn-width-full", { 'p-invalid': slotProps.data.name == null }],
                      modelValue: slotProps.data.name,
                      "onUpdate:modelValue": ($event: any) => (slotProps.data.name = $event),
                      options: _ctx.documentDataProp.datasetMeasures,
                      optionLabel: "id",
                      optionValue: "id"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "class"]),
                    (slotProps.data.name == null)
                      ? (_openBlock(), _createBlock("small", _hoisted_2, _toDisplayString(_ctx.$t('workspace.gis.fieldRequired')) + " *", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "label",
                  header: _ctx.$t('common.label'),
                  sortable: true
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_InputText, {
                      id: "label",
                      class: ["kn-material-input kn-width-full", { 'p-invalid': slotProps.data.label == null || slotProps.data.label == '' }],
                      modelValue: slotProps.data.label,
                      "onUpdate:modelValue": ($event: any) => (slotProps.data.label = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                    (slotProps.data.label == null || slotProps.data.label == '')
                      ? (_openBlock(), _createBlock("small", _hoisted_3, _toDisplayString(_ctx.$t('workspace.gis.fieldRequired')) + " *", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  style: _ctx.styleDescriptor.style.trashColumn
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_Button, {
                      icon: "pi pi-trash",
                      class: "p-button-link",
                      onClick: ($event: any) => (_ctx.deleteIndicatorRow(slotProps))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        })
      ], 4)
    ])
  ], 64))
}